/**
 * CollapsibleSection Component
 * 
 * A reusable collapsible section for the word popover with optional refresh button.
 */

import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';

export function CollapsibleSection({ title, defaultOpen = false, onRefresh, headerExtra, children }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <section className="forge-section">
      <div className="flex items-center justify-between">
        <button
          className="forge-section-title flex-1 text-left"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`forge-arrow ${isOpen ? 'open' : ''}`}>&#9656;</span>
          {title}
        </button>
        <div className="flex items-center gap-1">
          {headerExtra}
          {onRefresh && (
            <button
              className="forge-refresh-btn"
              onClick={(e) => { e.stopPropagation(); onRefresh(); }}
              title="Refresh with AI"
            >
              <RefreshCw size={13} />
            </button>
          )}
        </div>
      </div>
      {isOpen && <div className="forge-section-body">{children}</div>}
    </section>
  );
}

export default CollapsibleSection;
